import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import OrderTable from '@accounting/components/tables/order-table/order-table.vue';

@Component({
  name: 'bpc-orders',
  components: {
    'bpc-order-table': OrderTable,
  },
})
export default class Orders extends Vue {
  public accountingJournalsType: string[] = ['invoice', 'credit_note'];
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
